import { render, staticRenderFns } from "./HotelAllocation.vue?vue&type=template&id=2f6b2cd6&scoped=true&"
import script from "./HotelAllocation.vue?vue&type=script&lang=js&"
export * from "./HotelAllocation.vue?vue&type=script&lang=js&"
import style0 from "./HotelAllocation.vue?vue&type=style&index=0&id=2f6b2cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b2cd6",
  null
  
)

export default component.exports